(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");

    if (productRecommendationsSection === null) { return false; }

    var recommended_url = productRecommendationsSection.dataset.baseUrl;

    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;

    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;

    // Build request URL
    var requestUrl = recommended_url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      }
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();
  
  // Filter products by city
  function filterRecommendationsByCity() {
    const selectedCity = window.getCurrentCity ? window.getCurrentCity() : null;
    const products = document.querySelectorAll('.product-recommendations .product[data-product-cities]');
    
    if (!selectedCity) {
      // Si no hay ciudad seleccionada, mostrar todos los productos
      products.forEach(product => {
        product.style.display = '';
      });
      return;
    }
    
    // Filtrar productos según la ciudad
    products.forEach(product => {
      const productCities = product.getAttribute('data-product-cities');
      if (productCities && productCities.includes(selectedCity)) {
        product.style.display = '';
      } else {
        product.style.display = 'none';
      }
    });
  }
  
  // Observe mutations to filter products when they are loaded
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        filterRecommendationsByCity();
      }
    });
  });
  
  const targetNode = document.querySelector('.product-recommendations');
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }
  
  // Listen for city changes
  document.addEventListener('citySelected', function(e) {
    filterRecommendationsByCity();
  });
  
  // Filter when city selector is ready
  setTimeout(function() {
    if (window.getCurrentCity) {
      filterRecommendationsByCity();
    }
  }, 500);

  } catch(e) { console.error(e); }
})();
})();
